import Grid from "@mui/material/Grid";

import { LoadingOrValue } from "@covertree/ui";
import DisplayPropertiesCard from "@covertree/ui/content/DisplayPropertiesCard";
import { PolicyWithAgencyDataFragment } from "@covertree/agent-portal-graphql";

interface AgencyInformationProps {
  policy: PolicyWithAgencyDataFragment;
  loading: boolean;
}

export function AgencyInformation({ policy, loading }: AgencyInformationProps) {
  return (
    <>
      <Grid item xs={12}>
        <DisplayPropertiesCard
          properties={[
            {
              label: "Agency name",
              value: (
                <LoadingOrValue
                  loading={!policy && loading}
                  value={policy?.agencyInformation?.agencyName ?? "N/A"}
                  height={24}
                  width={121}
                />
              ),
              showAsTypography: true,
              gridSize: 6,
            },
            {
              label: "Agency ID",
              value: (
                <LoadingOrValue
                  loading={!policy && loading}
                  value={policy?.agencyInformation?.agencyId ?? "N/A"}
                  height={24}
                  width={121}
                />
              ),
              showAsTypography: true,
              gridSize: 6,
            },
            {
              label: "Agent on record name",
              value: (
                <LoadingOrValue
                  loading={!policy && loading}
                  value={policy?.agencyInformation?.agentName ?? "N/A"}
                  height={24}
                  width={121}
                />
              ),
              showAsTypography: true,
              gridSize: 6,
            },
            {
              label: "Agent on record ID",
              value: (
                <LoadingOrValue
                  loading={!policy && loading}
                  value={policy?.agencyInformation?.agentId ?? "N/A"}
                  height={24}
                  width={121}
                />
              ),
              showAsTypography: true,
              gridSize: 6,
            },
          ]}
        />
      </Grid>
    </>
  );
}
